import pcUrl from '@planningcenter/url'
import store from './store'

let apiEnv = 'production'

if (process.env.NODE_ENV === 'development') {
  apiEnv = store.get('apiSource') || 'production'
}

const apiBaseUrl = pcUrl(apiEnv)('api')

export { apiEnv }
export default apiBaseUrl
